import React, { useState } from 'react';
import PortfolioCard from './PortfolioCard';
import MovieDatabase from './MovieDatabase';
import './App.css';

function App() {
  const [activeProject, setActiveProject] = useState('portfolio');

  return (
    <div className="app">
      <nav className="nav">
        <button 
          className={activeProject === 'portfolio' ? 'active' : ''}
          onClick={() => setActiveProject('portfolio')}
        >
          Part A - Portfolio Card
        </button>
        <button 
          className={activeProject === 'movie' ? 'active' : ''}
          onClick={() => setActiveProject('movie')}
        >
          Part B - Movie Database
        </button>
      </nav>
      
      {activeProject === 'portfolio' ? (
        <div className="container">
          <PortfolioCard />
        </div>
      ) : (
        <MovieDatabase />
      )}
    </div>
  );
}

export default App;